export const SET_ALUMNI_BLESS_SUCCESS = 'SET_ALUMNI_BLESS_SUCCESS';
export const SET_IDX_BULLET_SCREEN_LIST = 'SET_IDX_BULLET_SCREEN_LIST';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
